import Card10C from './cards/10C.svg';
import Card10D from './cards/10D.svg';
import Card10H from './cards/10H.svg';
import Card10S from './cards/10S.svg';
import Card2C from './cards/2C.svg';
import Card2D from './cards/2D.svg';
import Card2H from './cards/2H.svg';
import Card2S from './cards/2S.svg';
import Card3C from './cards/3C.svg';
import Card3D from './cards/3D.svg';
import Card3H from './cards/3H.svg';
import Card3S from './cards/3S.svg';
import Card4C from './cards/4C.svg';
import Card4D from './cards/4D.svg';
import Card4H from './cards/4H.svg';
import Card4S from './cards/4S.svg';
import Card5C from './cards/5C.svg';
import Card5D from './cards/5D.svg';
import Card5H from './cards/5H.svg';
import Card5S from './cards/5S.svg';
import Card6C from './cards/6C.svg';
import Card6D from './cards/6D.svg';
import Card6H from './cards/6H.svg';
import Card6S from './cards/6S.svg';
import Card7C from './cards/7C.svg';
import Card7D from './cards/7D.svg';
import Card7H from './cards/7H.svg';
import Card7S from './cards/7S.svg';
import Card8C from './cards/8C.svg';
import Card8D from './cards/8D.svg';
import Card8H from './cards/8H.svg';
import Card8S from './cards/8S.svg';
import Card9C from './cards/9C.svg';
import Card9D from './cards/9D.svg';
import Card9H from './cards/9H.svg';
import Card9S from './cards/9S.svg';
import CardAC from './cards/AC.svg';
import CardAD from './cards/AD.svg';
import CardAH from './cards/AH.svg';
import CardAS from './cards/AS.svg';
import CardBLUE_BACK from './cards/BLUE_BACK.svg';
import CardJC from './cards/JC.svg';
import CardJD from './cards/JD.svg';
import CardJH from './cards/JH.svg';
import CardJS from './cards/JS.svg';
import CardKC from './cards/KC.svg';
import CardKD from './cards/KD.svg';
import CardKH from './cards/KH.svg';
import CardKS from './cards/KS.svg';
import CardQC from './cards/QC.svg';
import CardQD from './cards/QD.svg';
import CardQH from './cards/QH.svg';
import CardQS from './cards/QS.svg';
import CardRED_BACK from './cards/RED_BACK.svg';
import CardTC from './cards/TC.svg';
import CardTD from './cards/TD.svg';
import CardTH from './cards/TH.svg';
import CardTS from './cards/TS.svg';

const Cards = {
  '10C': Card10C,
  '10D': Card10D,
  '10H': Card10H,
  '10S': Card10S,
  '2C': Card2C,
  '2D': Card2D,
  '2H': Card2H,
  '2S': Card2S,
  '3C': Card3C,
  '3D': Card3D,
  '3H': Card3H,
  '3S': Card3S,
  '4C': Card4C,
  '4D': Card4D,
  '4H': Card4H,
  '4S': Card4S,
  '5C': Card5C,
  '5D': Card5D,
  '5H': Card5H,
  '5S': Card5S,
  '6C': Card6C,
  '6D': Card6D,
  '6H': Card6H,
  '6S': Card6S,
  '7C': Card7C,
  '7D': Card7D,
  '7H': Card7H,
  '7S': Card7S,
  '8C': Card8C,
  '8D': Card8D,
  '8H': Card8H,
  '8S': Card8S,
  '9C': Card9C,
  '9D': Card9D,
  '9H': Card9H,
  '9S': Card9S,
  AC: CardAC,
  AD: CardAD,
  AH: CardAH,
  AS: CardAS,
  BLUE_BACK: CardBLUE_BACK,
  JC: CardJC,
  JD: CardJD,
  JH: CardJH,
  JS: CardJS,
  KC: CardKC,
  KD: CardKD,
  KH: CardKH,
  KS: CardKS,
  QC: CardQC,
  QD: CardQD,
  QH: CardQH,
  QS: CardQS,
  RED_BACK: CardRED_BACK,
  TC: CardTC,
  TD: CardTD,
  TH: CardTH,
  TS: CardTS,
};

export default Cards;
